import { motion } from "framer-motion";
import { isValidElement } from "react";

export const ease = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", testId }) => (
  <motion.div
    data-testid={testId}
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease, delay }}
  >
    {children}
  </motion.div>
);

// Copy lines are unique text; rich-text lines supply an explicit React key.
export const MaskLines = ({ lines, delay = 0, className = "", lineClassName = "" }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={isValidElement(line) ? `element:${line.key}` : `text:${line}`} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%", rotate: 2 }}
          animate={{ y: "0%", rotate: 0 }}
          transition={{ duration: 1.15, ease, delay: delay + i * 0.13 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Eyebrow = ({ children, light = false, className = "" }) => (
  <p className={`font-mono-ega text-xs uppercase tracking-[0.25em] flex items-center gap-3 ${light ? "text-[#D4AF37]" : "text-[#0F5A47]"} ${className}`}>
    <span className={`h-px w-8 ${light ? "bg-[#D4AF37]" : "bg-[#0F5A47]"}`} />
    {children}
  </p>
);
